module.exports = __webpack_public_path__ + "static/media/Tawuniya_Vitality.66eb8292.svg";